import { put, all } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { keysToSnakeCase } from "lib/helpers";
import messages from "../messages";

function* createNewAdminNotice(action) {
  const params = keysToSnakeCase(action.payload);
  const { success, data, error } = yield* makeRequest.post("/notices/", params);
  if (success && data) {
    yield all([
      put(
        actions.newSuccessEvent({
          message: messages.SUCCESS_CREATING_NEW_ADMIN_NOTICE,
          payload: data.body,
        }),
      ),
      put(actions.getAdminNoticesList()),
    ]);
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_CREATING_NEW_ADMIN_NOTICE,
    });
  }
  return null;
}

export default createNewAdminNotice;
